// extracted by mini-css-extract-plugin
var _1 = "PortalAnswerItem_badge__52ea7";
var _2 = "PortalAnswerItem_counter__1b1cd";
var _3 = "PortalAnswerItem_fadeIn__c69a0";
var _4 = "PortalAnswerItem_groupBadge__72dd7";
var _5 = "PortalAnswerItem_icon__bb68b";
var _6 = "PortalAnswerItem_iconWrapper__bb841";
var _7 = "PortalAnswerItem_label__2b827";
var _8 = "PortalAnswerItem_mask__bd67b";
var _9 = "PortalAnswerItem_navButton__afd16";
var _a = "PortalAnswerItem_navigation__ecc77";
var _b = "PortalAnswerItem_outline__41280";
var _c = "PortalAnswerItem_placeholder__c308c";
var _d = "PortalAnswerItem_textInner__45c21";
var _e = "PortalAnswerItem_toolbar__d3f19";
export { _1 as "badge", _2 as "counter", _3 as "fadeIn", _4 as "groupBadge", _5 as "icon", _6 as "iconWrapper", _7 as "label", _8 as "mask", _9 as "navButton", _a as "navigation", _b as "outline", _c as "placeholder", _d as "textInner", _e as "toolbar" }
